import { UserNotificationEnum } from 'src/apollo/generated/graphql'

const TITLE_BY_TYPE: Record<
  UserNotificationEnum,
  (userFullName: string) => string
> = {
  USER_ACCEPTED_INVATION: name => `${name} accepted the invitation`,
  SHIFT_EARLY_END_PENDING: name => `${name} requested an early shift end`,
  SHIFT_EARLY_END_ACCEPTED: name => `Early end accepted for ${name}`,
  SHIFT_EARLY_ENDED: name => `${name} ended a shift early`,
}

export const buildNotificationTitle = (
  type: UserNotificationEnum,
  userFullName: string,
): string => TITLE_BY_TYPE[type](userFullName)

export const getNotificationSubjectName = (data: {
  user?: { fullName: string } | null
}): string => data.user?.fullName ?? 'Someone'
